import React from "react";
import SupportForm from "../../components/admin/support/SupportForm";
import FAQSection from "../../components/admin/support/FAQSection";
import ContactOptions from "../../components/admin/support/ContactOptions";

export default function SupportPage() {
  return (
    <div className="p-8 bg-white dark:bg-gray-800 rounded-lg shadow md:ml-64 max-w-5xl mx-auto space-y-12">
      <h2 className="text-3xl font-bold text-gray-900 dark:text-white text-center mb-8">
        Support Center
      </h2>

      <SupportForm />
      <FAQSection />
      <ContactOptions />
    </div>
  );
}
